import mapboxgl from 'mapbox-gl';

import { Language } from '@project44/translations-utils';

// https://docs.mapbox.com/mapbox-gl-js/example/language-switch/

export const setLanguage = (map: mapboxgl.Map, language: Language) => {
  const mapping: Partial<Record<Language, string>> = {
    zh: 'zh-Hans', // Simplified Chinese
  };

  const lang = mapping[language] || language;

  (map.getStyle().layers || []).forEach((l) => {
    try {
      map.setLayoutProperty(l.id, 'text-field', ['get', `name_${lang}`]);
    } catch (e) {}
  });
};

// https://docs.mapbox.com/mapbox-gl-js/example/toggle-worldviews/

export const setWorldview = (map: mapboxgl.Map, isChina: boolean) => {
  const worldview = isChina ? 'CN' : 'US';

  map.setFilter('admin-0-boundary-disputed', [
    'all',
    ['==', ['get', 'disputed'], 'true'],
    ['==', ['get', 'admin_level'], 0],
    ['==', ['get', 'maritime'], 'false'],
    ['match', ['get', 'worldview'], ['all', worldview], true, false],
  ]);

  map.setFilter('admin-0-boundary', [
    'all',
    ['==', ['get', 'admin_level'], 0],
    ['==', ['get', 'disputed'], 'false'],
    ['==', ['get', 'maritime'], 'false'],
    ['match', ['get', 'worldview'], ['all', worldview], true, false],
  ]);

  map.setFilter('admin-0-boundary-bg', [
    'all',
    ['==', ['get', 'admin_level'], 0],
    ['==', ['get', 'maritime'], 'false'],
    ['match', ['get', 'worldview'], ['all', worldview], true, false],
  ]);
};
